module.exports = __webpack_public_path__ + "static/media/sports_and_entertainment.1626e1f2.png";